import React, { useState, useEffect, memo } from 'react';

const LiveClock = memo(() => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="text-center sm:text-right bg-gray-800/50 rounded-xl p-3 sm:p-4 border border-gray-700/50">
      <p className="text-lg sm:text-xl lg:text-2xl font-bold text-white mb-1">
        {currentTime.toLocaleDateString()}
      </p>
      <p className="text-base sm:text-lg font-semibold text-blue-400">
        {currentTime.toLocaleTimeString()}
      </p>
    </div>
  );
});

LiveClock.displayName = 'LiveClock';

export default LiveClock;
